import { createContext, useState, useEffect, useContext, useMemo } from "react";
import { Periodicity } from "../services/PeriodicityService";
import { getAccessTokenLocalStorage, ValidAccessTokenLocalStorage, handleUserLogOutErro } from "../context/utils"
import { UserPreferenceContext } from "../context/UserPreferenceContext";
import PropTypes from 'prop-types';
export const PeriodicityContext = createContext();

const PeriodicityProvider = ({ children }) => {
    const [periodicity, setPeriodicity] = useState([]);
    const [countryId, setCountryId] = useState(1);
    const { userAuthenticated, setUserAuthenticated ,setUserMenssageApi } = useContext(UserPreferenceContext);

    function changeCountryId(id) {
        setCountryId(id);
    }

    async function doPeriodicity(countryId) {
        setCountryId(countryId);
        let token = getAccessTokenLocalStorage();
        if (ValidAccessTokenLocalStorage()) {
            await Periodicity(token, countryId
            ).then(res => {
                setPeriodicity(res.data);
            })
                .catch(err => {
                    handleUserLogOutErro(err, userAuthenticated, setUserAuthenticated, setUserMenssageApi)
                });
        }
    };

    const value = useMemo(
        () => ({
          periodicity,
          doPeriodicity,
          changeCountryId,
        }),
        [periodicity, countryId]
      );
    return (
        <PeriodicityContext.Provider
            value={ value }
        >
            {children}
        </PeriodicityContext.Provider>
    );
}
PeriodicityProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default PeriodicityProvider;